<template>
    <div></div>
</template>

<script>

    import {Metadata, Template, Parameter, Instance, OP, DATUM, Operators, Table, Field, Enum, i18n} from '../../mould';

    export default {

        name: 'Test4',

        data(){
            return {

            }
        },

        mounted(){

            Metadata.useExample();
            let username = Metadata.fieldsList()[1];
            let gender = Metadata.fieldsList()[3];
            let nationality = Metadata.fieldsList()[4];

            let inst = new Instance({template: OP('in.str')});
            inst.setValue('$1', nationality);
            // inst.setValue('$2', ['cn', 'jp', 'us']);
            // inst.setValue('$2', ['cn', 'ss']);
            inst.setValue('$2', [nationality.getEnums()[1], nationality.getEnums()[0]]);
            console.log(inst.outputText());
            console.log(inst.outputText('display'));
            console.log(inst.isLegitimate())

        },

        methods: {

        }
    }
</script>

<style scoped>

</style>